<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            modalWidth="90%"
            @action="masterAction"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha seguimiento')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['date_tracing', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Próximo seguimiento')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['next_tracing', { rules: [{ required: false, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-lookup :label="$t('Encargado')"
                    :formItemConfig="fiOptions"
                    ref="empleado"
                    endpoint="empleados"
                    :decorator="['id_emp', { rules: [{ required: false, message: 'Valor requerido' }] }]"
          >
          </g-lookup>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Tipo de seguimiento')"
                      style="width: 100%"
                      :formItemConfig="fiOptions"
                      :decorator="['id_h_tracing_type', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                      :params="casos_tipo_seguimiento">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Observaciones')" v-bind="fiOptions">
            <a-textarea autoSize
                        v-decorator="['observation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['id_case'],
    data () {
      return {
        casos_tipo_seguimiento: {
          h_lookup_type: 'CASOS_TIPO_SEGUIMIENTO'
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'tracing_case',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_tracing_cases'
            },
            columns: [
              {title: 'Fecha seguimiento', dataIndex: 'date_tracing_desc', sorter: true},
              {title: 'Próximo seguimiento', dataIndex: 'next_tracing_desc', sorter: true},
              {title: 'Observación', dataIndex: 'observation', sorter: true},
              {title: 'Id encargado', dataIndex: 'id_emp', sorter: true},
              {title: 'Encargado', dataIndex: 'full_name', sorter: true},
              {title: 'Tipo de seguimiento', dataIndex: 'h_tracing_type', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'date_tracing'},
            {name: 'next_tracing'},
            {name: 'observation'},
            {name: 'id_emp'},
            {name: 'id_h_tracing_type'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.id_t_legal_entity = action.record.id_t_legal_entity
            this.$nextTick(() => {
              if (!this.$isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
            })
            break
        }
      }
    },
    computed: {
      parentData () {
        return {id_case: this.id_case}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/TracingCase.vue